import { render } from "./TokenTY.vue?vue&type=template&id=75c09c8c&scoped=true"
import script from "./TokenTY.vue?vue&type=script&lang=js"
export * from "./TokenTY.vue?vue&type=script&lang=js"

import "./TokenTY.vue?vue&type=style&index=0&id=75c09c8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c09c8c"]])

export default __exports__